import { EmptyState, ErrorState, Skeleton } from '@/components/ui/Feedback'
import { PageHeader } from '@/components/ui/Page'
import { LiveIcon } from '@/components/icons'
import { AlertsToggle } from '@/features/live/AlertsToggle'
import { LiveQueueList } from '@/features/live/LiveQueueList'
import { PracticeCard } from '@/features/live/PracticeCard'
import { useLiveQueue } from '@/features/live/live'

/** Every check waiting for a person right now, across all users, the one with the least time left first. */
export function LiveQueuePage() {
  const { items, isLoading, isError, refetch } = useLiveQueue()
  return (
    <>
      <PageHeader
        title="Live checks"
        description="Pages a CAPTCHA or a human check has stopped, for any user. Open one to clear it for them. Either you or the user can do it."
        actions={<AlertsToggle />}
      />
      <section className="card overflow-hidden">
        {isLoading ? (
          <div className="space-y-3 p-5">
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
          </div>
        ) : isError ? (
          <ErrorState title="The queue could not be read" description="The API or Redis may be down." onRetry={() => void refetch()} />
        ) : items.length === 0 ? (
          <EmptyState
            icon={<LiveIcon className="h-7 w-7" />}
            title="Nothing waiting"
            description="A check shows here the moment a run meets one, with the time left to clear it. Turn alerts on to hear it arrive."
          />
        ) : (
          <LiveQueueList items={items} />
        )}
      </section>
      <PracticeCard />
    </>
  )
}
